// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { withPageMeta } from '@gandi/app-runner';
import { notifyDanger } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';

import PreferencesWidget from '../Layout/components/PreferencesWidget/PreferencesWidget';
import { Layout } from '../components/Layout';
import type { PreFetchArgs, FullState } from '../types';

import { useTmchPrices } from './hooks/useTmchPrices';
import { fetchPrices, fetchJurisdictions } from './modules/actions';

const Tmch = () => {
  const dispatch = useDispatch();
  const { __ } = useTranslator();
  const { pricesFailure, pricesFetching, pricesLoaded } = useTmchPrices();

  React.useEffect(() => {
    if (!pricesLoaded && !pricesFailure && !pricesFetching) {
      dispatch(fetchPrices()).then(
        response => response,
        error => {
          dispatch(
            notifyDanger(
              error.response?.data?.message || __('Unexpected error occurred'),
            ),
          );
        },
      );
    }
  }, [__, dispatch, pricesFailure, pricesFetching, pricesLoaded]);

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

Tmch.preFetch = function preFetch(
  args: PreFetchArgs<{}, void, empty, FullState>,
) {
  return Promise.allSettled([
    PreferencesWidget.preFetch(args),
    args.dispatch(fetchPrices()),
    args.dispatch(fetchJurisdictions()),
  ]);
};

export default (withPageMeta(({ __ }) => ({
  title: __(
    'Protect your brand online, subscribe to the Trademark Clearinghouse (TMCH) - Gandi.net',
  ),
  description: __(
    'Register your brand at the Trademark Clearinghouse to protect it when new extensions are launched.',
  ),
}))(Tmch): React.ComponentType<{}>);
